/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".logo[_ngcontent-%COMP%]{position:relative;top:1rem;left:1rem;height:3rem;z-index:1}.border[_ngcontent-%COMP%]{background:#1a1a1a;position:fixed;height:100vh;width:100%;border:1rem solid #000}.title[_ngcontent-%COMP%]{margin-left:30%;padding-left:60px;margin-right:30%;padding-right:60px;margin-top:30vh;line-height:36px;font-size:32px}.title[_ngcontent-%COMP%], .title[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%], .title[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{color:#e7f5ff}.title[_ngcontent-%COMP%]   h3[_ngcontent-%COMP%]{font-size:22px}"];
export { styles as styles };

